import { DatePicker } from 'antd';
import {
  DEFAULT_MIN_DATE_RANGE,
  MAX_DATE_RANGE,
  MIN_DATE_RANGE,
} from 'constants/constants';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import { Button, Col } from 'react-bootstrap';
import { flushSync } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setEngagementFilters } from 'store/customer/customerViewSlice';
import classes from './RangePicker.module.scss';
const { RangePicker } = DatePicker;

const DateRangePicker = () => {
  const dispatch = useDispatch();
  const dateFormat = 'MMM DD, YYYY';
  const minStartDate = dayjs().subtract(MAX_DATE_RANGE, 'year');

  const engagementsFilters = useSelector(
    (state) => state?.CustomerView?.engagementFilters
  );

  const selectedStartDate = useSelector(
    (state) => state?.CustomerView?.engagementFilters?.startDate?.selectedValue
  );

  const selectedEndDate = useSelector(
    (state) => state?.CustomerView?.engagementFilters?.endDate?.selectedValue
  );

  const [dates, setDates] = useState();

  const [prevDates, setPrevDates] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [flag, setFlag] = useState(true);

  const ignoreNextCloseRef = useRef(false);

  useEffect(() => {
    setDates([dayjs(selectedStartDate), dayjs(selectedEndDate)]);
    setPrevDates([dayjs(selectedStartDate), dayjs(selectedEndDate)]);
  }, [selectedStartDate, selectedEndDate]);

  const handleChange = (values) => {
    let [start, end] = values;
    let [csd, ced] = dates;

    if (flag) {
      if (
        start.isAfter(end, 'day') ||
        dayjs(end).diff(dayjs(start), 'months') > MIN_DATE_RANGE
      ) {
        if (csd.isSame(start, 'day')) {
          flushSync(() => setFlag(false));
          start = end;
        } else if (ced.isSame(end, 'day')) {
          flushSync(() => setFlag(false));
          end = start;
        }
      }

      flushSync(() => setDates([dayjs(start), dayjs(end)]));
    } else {
      flushSync(() => setDates([csd, ced]));
      flushSync(() => setFlag(true));
    }
  };

  const handleApply = () => {
    ignoreNextCloseRef.current = false;
    setIsOpen(false);
    dispatch(
      setEngagementFilters({
        ...engagementsFilters,
        startDate: { selectedValue: dates[0].toDate() },
        endDate: { selectedValue: dates[1].toDate() },
      })
    );
  };

  const handleOpenChange = (open) => {
    if (!open && !ignoreNextCloseRef.current) {
      setIsOpen(false);
      setDates(prevDates);
    } else if (open) {
      setPrevDates(dates);
      setIsOpen(true);
    }
  };

  useEffect(() => {
    const handleMouseDown = (e) => {
      if (
        e.target.closest('.ant-picker-dropdown') ||
        e.target.closest('.save-btn')
      ) {
        ignoreNextCloseRef.current = true;
      } else {
        ignoreNextCloseRef.current = false;
      }
    };

    document.addEventListener('mousedown', handleMouseDown);
    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  return (
    <Col className={classes['range-picker-container']}>
      <label className='title__x-small d-block'>
        Start / End Date{' '}
        <span className=' w-100 title title__x-small title__italic pt-0 m-0 title__grey ms-1'>
          Optimized for 6-month window.
        </span>
      </label>
      <div
        className={`custom-range-picker-wrapper ${isOpen ? 'calendar-open' : ''}`}>
        <RangePicker
          className='ant-picker-focused w-100'
          allowClear={false}
          format={dateFormat}
          value={dates}
          open={isOpen}
          minDate={minStartDate}
          maxDate={dayjs().subtract(DEFAULT_MIN_DATE_RANGE, 'day')}
          onCalendarChange={handleChange}
          onOpenChange={handleOpenChange}
          onClick={() => setIsOpen(true)}
          suffixIcon={<i className='icon icon__calendar m-0'> </i>}
          separator={<i className='icon icon__arrow-right' />}
          superPrevIcon={null}
          superNextIcon={null}
          renderExtraFooter={() => (
            <div className='d-flex justify-content-end align-items-center w-100 text-right my-1'>
              <Button
                className='btn btn-gne btn-primary py-1'
                onClick={handleApply}
                disabled={
                  !dates ||
                  (dates[0].isSame(prevDates[0], 'day') &&
                    dates[1].isSame(prevDates[1], 'day'))
                }>
                Apply
              </Button>
            </div>
          )}
        />
      </div>
    </Col>
  );
};

export default DateRangePicker;
